import React, { useState, useEffect } from "react";
import { Typography, Grid } from "@mui/material";
import JobDetailComp from "../../components/JobDetailComp";  // Make sure you have this component
import { useNavigate } from "react-router-dom";
import axios from "axios";
import moment from "moment";

export default function JobDetailsFun(props) {
  const navigate = useNavigate();
  const { jobId } = props; // If you are passing jobId as a prop. Otherwise, define it here.

  const [jobDetailsData, setJobDetailsData] = useState(null);
  const [loading, setLoading] = useState(true); // To track loading state
  const [error, setError] = useState(null); // To track errors

  useEffect(() => {
    // Function to fetch job details from API
    const fetchJobDetails = async () => {
      try {
        // Get the token (assuming it's stored in localStorage)
        const token = localStorage.getItem("authToken"); // Replace with actual token retrieval method

        // Make the API request with the token in the Authorization header
        const response = await axios.get(`https://jobmanagement-497524552274.us-central1.run.app/api/jobs/${jobId}`, {
          headers: {
            Authorization: `Bearer ${token}`, // Add token to the request headers
          },
        });
        setJobDetailsData(response.data); // Set fetched job data
      } catch (error) {
        setError("Error fetching job details");
        console.error(error);
      } finally {
        setLoading(false); // Set loading to false after fetching data
      }
    };

    fetchJobDetails();
  }, [jobId]); // Only re-run if jobId changes

  // Loading and error handling
  if (loading) {
    return <Typography>Loading job details...</Typography>;
  }

  if (error) {
    return <Typography>{error}</Typography>;
  }

  // Helper function to format date
  function DateConverter(data) {
    return moment(data).format("L");  // Format as "MM/DD/YYYY"
  }

  // Helper function to format time
  function TimeConverter(data) {
    return moment(data).format("LT");  // Format as "HH:mm AM/PM"
  }

  return (
    <>
      {/* Job Details Section */}
      <JobDetailComp JobDetailsData={jobDetailsData} />  {/* Assuming this component is available */}

      <Grid container sx={{ p: "4%", mt: "-30px" }}>
        <Grid item xs={12} sx={{ p: 2 }} className="main-box-viewJobs-card">
          {/* Job ID */}
          <div className="labelDivCls">
            <div className="labelCls">Job ID</div>
            <div className="valueCls">{jobDetailsData?.id}</div>
          </div>

          {/* Property Type */}
          <div className="labelDivCls">
            <div className="labelCls">Property Type</div>
            <div className="valueCls">{jobDetailsData?.propertyType}</div>
          </div>

          {/* Location/Address */}
          <div className="labelDivCls">
            <div className="labelCls">Location/Address</div>
            <div className="valueCls">{jobDetailsData?.address?.street}</div>
          </div>

          {/* Job Status */}
          <div className="labelDivCls">
            <div className="labelCls">Job Status</div>
            <div className="valueCls">{jobDetailsData?.status}</div>
          </div>

          {/* Date Requested */}
          <div className="labelDivCls">
            <div className="labelCls">Date Requested</div>
            <div className="valueCls">{DateConverter(jobDetailsData?.date)}</div>
          </div>

          {/* Time */}
          <div className="labelDivCls">
            <div className="labelCls">Time</div>
            <div className="valueCls">{TimeConverter(jobDetailsData?.time)}</div>
          </div>
        </Grid>
      </Grid>
    </>
  );
}
